/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_identity_pool_id": "ap-southeast-2:5cb7c4dd-cad6-4156-a77b-5729f6c3d3c7",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_dFtTvv2PB",
    "aws_user_pools_web_client_id": "19a1ac0ubjnq7ihhb1h1c12e8h",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://mggtyjgskvdb3ijmmvz2hup474.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "maiwar-react-storage04046-devsecond",
    "aws_user_files_s3_bucket_region": "ap-southeast-2"
};


export default awsmobile;
